import Vue from 'vue';

export const EventComponentBus = new Vue({
    methods: {
		/**
		 * @public
		 * @description
		 * Emits a promise as event with an event object
		 * When promised is resolved hides a system popup and return promise result
		 *
		 * @param { Object } event
		 *
		 */
		showSystemPopup(event, callback) {
			return new Promise((resolve) => {
				this.$emit('csShowSystemPopup', event, resolve, callback);
			})
			.then((response) => {
				this.hideSystemPopup();
				
				return response;
			});
		},

		/**
		 * @public
		 * @description
		 * Emits an event to hide system popup
		 */
		hideSystemPopup() {
			this.$emit('csHideSystemPopup');
		},

		/**
		 * @public
		 * @description
		 * Toggles navigation popup visibility
		 *
		 * @param { Boolean } event Show or hide
		 * @param {String} entityUrl The current entity url, if any
		 * @param { Array } items List of items for navigation
		 * @param { Object } target Parent item DOMRect
		 */
		toggleNavigationPopup(event, entityUrl, items, target) {
			const options = {
				active: event || false,
				entityUrl : entityUrl,
				navigation: items || [],
				target: target || ''
			};

			this.$emit('csToggleNavigationPopup', options);

			if ( !event ) {
				this.$emit('csClearNavigationPopup');
			}
		},

		/**
		 * @public
		 * @description
		 * Emits an event when sidebar has been toggled
		 */
		toggleSidebar() {
			this.$emit('csToggleSidebar');
		},

		/**
		 * @public
		 * @description
		 * Emits an event when component settings overlay has been toggled
		 */
		toggleComponentSettingsOverlay() {
			this.$emit('csToggleComponentSettingsOverlay');
		},

		/**
		 * @public
		 * @description
		 * Emits an event to toggle a form overlay in the indicate place in the app
		 * 
		 * @param { Object } form 
		 */
		toggleReportsDashboardFormOverlay(form) {
			this.$emit('csToggleReportsDashboardForm', form);
		},

		/**
		 * @public
		 * @description
		 * Emits an event with a form params object
		 * 
		 * @param { Object } callback the form params
		 */
		sendReportsDashboardFormCallback(callback) {
			this.$emit('csReportsDahsboardFromCallback', callback);
		},

		/**
		 * @public
		 * @description
		 * Looks for a reports dashboard form callback
		 * 
		 * @param { Object } callback the form params
		 */
		receiveReportsDashboardFormCallback(callback) {
			return this.$on('csReportsDahsboardFromCallback', callback);
		},

       /**
		* @public
        * @description
        * Emits an object with an index and percent value of loaded component
        *
        * @param { Number } index
        * @param { Number } percent
        */
        updateLoadPercent(index, percent) {
            this.$emit('csComponentLoadUpdated', { index, percent });
		},
		
		/** USER EVENTS */
		/**
		 * @public
		 * @description
		 * Emits a user profile reload request when user has been updated
		 *
		 */
		updateUserProfile() {
			this.$emit('csUserProfileUpdated');
		},

		/**
		 * @description
		 * Emits an event to clear user personal settings
		 * @param { Object } componentSettings
		 */
		clearUserPersonalisedSettings(componentSettings = undefined) {
			this.$emit('csUserClearPerosnalisedSettings', componentSettings);
		},

		/** FIELD EVENTS */
		/**
		 * @description
		 * Next broadcast that the field has changed to its child cascade elements so that they may update
		 *
		 * @event csFormCascadeParentChanged
		 * @type {Object}
		 */
		emitCascadeFieldChange(field, parentRefString) {
			this.$emit(`csFormCascadeParentChanged:${field.id}-${parentRefString}`, field);
		}, 

		/**
		 * @description
		 * Broadcast that the filter has changed to its child cascade elements so that they may update
		 *
		 * @event csFilterCascadeParentChanged
		 * @type {Object}
		 */
		emitCascadeFilterChange(filter, reference) {
			this.$emit(`csFilterCascadeParentChanged:${filter.collectionId}_${filter.fieldId}_${reference}`, filter);
		}, 

		/**
		 * @description
		 * Sets a cascade for a given collection as in progress or not
		 * 
		 * @param {String} collectionId the collection cascade triggered.
		 * @param {String} senderId the id of the first result field.
		 * @event csCascadeStateChanged
		 */
		emitCascadeCombinedValueQueryCompleted(collectionId, senderId) {
			this.$emit('csCascadeCombinedValueQueryCompleted', collectionId, senderId);
		},

		/**
		 * @description
		 * Broadcast a show notification request
		 * 
		 * @param {String} type The notification type to display
         * @param {String} text The notification text to display
         * @param {Boolean} dismissible Whether the notification can be dismissed 
         * @param {String|Integer} duration A string specifying the duration or an integer in milliseconds. 0 plus dismissible means it must be dismissed
         * @returns void
		 */
		showNotification(type, text, dismissible, duration, colour) {
			/**
            * @event componentLoadInfo
            * @type {object}
            * @description
            * Passes the data on to the next level
            * 
            * @property {String} type The notification type to display
            * @property {String} text The notification text to display
            * @property {Boolean} dismissible Whether the notification can be dismissed 
            * @property {String|Integer} duration A string specifying the duration or an integer in milliseconds. 0 plus dismissible means it must be dismissed
            * @property { String } colour A HEX value of the colour for the notification
            */
		   this.$emit('csShowNotification', type, text, dismissible, duration, colour);
		}
    }
});

